export default __webpack_public_path__ + "media/zurb/img/icons/services/system-feaed9ab03e1cd2ce1cab7a0c2c02bb4.svg";